import React, { PureComponent } from 'react';

import './page-not-found.scss';

class PageNotFound extends PureComponent {
    constructor(props) {
        super(props);

        this.routeRecipes = this.routeRecipes.bind(this);
        this.routeProducts = this.routeProducts.bind(this);
    }

    routeRecipes(){
        let path = `/recipes`;
        this.props.history.push(path);
    }

    routeProducts(){
        let path = `/products`;
        this.props.history.push(path);
    }

    render() {
        return (
            <div className="body-wrapper column page404">
                <h1>404 - page not found</h1>
                <div className="p-block">
                    <p>We couldn't find the page you're looking for. Try browsing any of our products or recipes.</p>
                </div>
                <div>
                    <button onClick={this.routeRecipes}>See recipes</button>
                    <button onClick={this.routeProducts}>See products</button>
                </div>
            </div>
        );
    }
}

export default PageNotFound;
